import { gql } from '@apollo/client'

import { editFragment } from 'js/magazine/lib/fragments'

export const MAGAZINE_EDIT_WRAPPER = gql`
    query MagazineEditWrapper($guid: String!) {
        entity(guid: $guid) {
            guid
            ${editFragment}
        }
    }
`
